module.exports = __webpack_public_path__ + "img/logo1.d0440e10.png";